import React from "react";
import { ModalBody } from "reactstrap";
import styles from "./branddetail.module.scss";
import Proptypes from "prop-types";
import Modal from "../../../Modal";
import StatusDropdown from "../../StatusDropdown";
import MenuIconWhite from "../../../../assets/images/menu-icon-white.svg";
import StatusIndicator from "../../StatusIndicator";
import { useSelector } from "react-redux";
import { format } from "date-fns";

const BrandsDetailModal = ({
  currentBrandId,
  openModal,
  toggle,
  setLoading,
}) => {
  const brandData = useSelector((state) => state?.appReducer)?.brands;
  const currentBrand = (brandData || [])?.find(
    (brand) => brand?.id === currentBrandId
  );
  const userData = useSelector((state) => state.authReducer);
  const isAdmin = userData?.role === "admin" || false;
  const brandStatus = currentBrand?.status;
  const createdDate = format(
    new Date(currentBrand?.createdAt),
    "h:mm a M/d/yy"
  )?.split(" ");
  createdDate?.splice(2, 0, "on");
  const dateString = createdDate?.join(" ");

  const handleDownload = () => {
    if (!currentBrand.images || currentBrand.images.length === 0) {
      alert("No files available for download.");
      return;
    }

    currentBrand.images.forEach((fileUrl) => {
      fetch(fileUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch ${fileUrl}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = fileUrl.split("/").pop(); // Extract filename from URL
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
          URL.revokeObjectURL(url); // Clean up the blob URL
        })
        .catch((error) => {
          console.error("Download failed:", error);
        });
    });
  };

  return (
    <>
      <Modal openModal={openModal} toggle={toggle}>
        <ModalBody className={styles["modal_body"]}>
          <div className={styles["header_content"]}>
            <div className={styles["header_container"]}>
              <p className={styles["header_heading"]}>
                {currentBrand?.brandName || "-"}
              </p>
            </div>
            <div className={styles["status_div"]}>
              {isAdmin && (
                <button
                  className={styles["download_button"]}
                  onClick={handleDownload}
                >
                  Download
                </button>
              )}

              <StatusIndicator currentStatus={brandStatus} />
              {isAdmin ? (
                <div>
                  <StatusDropdown
                    customMenuObject={{
                      icon: MenuIconWhite,
                      width: 20,
                      height: 20,
                    }}
                    brandId={currentBrand?.id}
                    currentStatus={currentBrand?.status}
                    setLoading={setLoading}
                    onComplete={() => {}}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div
            style={{
              // marginTop: '8px',
              marginBottom: "20px",
            }}
          >
            <p className={styles["label_data"]}>
              Date Added: {dateString || "-"}
            </p>
          </div>
          <div
            style={{
              marginBottom: "12px",
            }}
          >
            <p className={styles["label_data"]}>
              {currentBrand?.descriptionOrBrand || "-"}
            </p>
          </div>
          <div
            className={styles["lower_border"]}
            style={{
              marginBottom: "15px",
            }}
          />

          <div className={styles["box_wrapper"]}>
            <div className={styles["box"]}>
              <h6 className={styles["label_title"]}>Business Name</h6>
              <p className={styles["label_data"]}>
                {currentBrand?.businessEntityName || "-"}
              </p>
            </div>
            <div className={styles["box"]}>
              <h6 className={styles["label_title"]}>
                Business Registration Number
              </h6>
              <p className={styles["label_data"]}>
                {currentBrand?.businessRegistrationNumber || "-"}
              </p>
            </div>
          </div>

          <div className={styles["box_wrapper"]}>
            <div className={styles["box"]}>
              <h6 className={styles["label_title"]}>Address Line 1</h6>
              <p className={styles["label_data"]}>
                {currentBrand?.city || "-"}
              </p>
            </div>
            <div className={styles["box"]}>
              <h6 className={styles["label_title"]}>Address Line 2</h6>
              <p className={styles["label_data"]}>
                {currentBrand?.state || "-"}
              </p>
            </div>
          </div>

          <div className={styles["box_wrapper"]}>
            <div className={styles["box"]}>
              <h6 className={styles["label_title"]}>City</h6>
              <p className={styles["label_data"]}>
                {currentBrand?.city || "-"}
              </p>
            </div>
            <div className={styles["box"]}>
              <h6 className={styles["label_title"]}>State</h6>
              <p className={styles["label_data"]}>
                {currentBrand?.state || "-"}
              </p>
            </div>
          </div>
          <div
            className={styles["lower_border"]}
            style={{
              marginTop: "15px",
            }}
          />
          <div
            style={{
              marginTop: "17px",
            }}
          >
            <p className={styles["other_brands_label"]}>
              Other Brands with name:{" "}
              <span className={styles["other_brands_data"]}>
                {currentBrand?.otherBrands || "-"}
              </span>
            </p>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

BrandsDetailModal.propTypes = {
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
  currentBrandId: Proptypes.string,
};

export default BrandsDetailModal;
